import { 
  CommonModule 
} from '@angular/common';
import { 
  Component, 
  ElementRef, 
  Input, 
  ViewChild, 
  AfterViewInit, 
  OnChanges, 
  SimpleChanges 
} from '@angular/core';

@Component({
  selector: 'app-facultad-autoridades',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './facultad-autoridades.component.html',
  styleUrl: './facultad-autoridades.component.scss'
})
export class FacultadAutoridadesComponent implements AfterViewInit, OnChanges {

  @Input() autoridadesLista: any[] = [];
  @Input() color = "";
  @ViewChild('slider') sliderRef!: ElementRef<HTMLDivElement>;

  @Input() autoridadPrincipal: any = null;
  @Input() modal: any = true;
  restoAutoridades: any[] = [];

  canScrollLeft = false;
  canScrollRight = true;

  // 1. Se ejecuta automáticamente cada vez que cambian las propiedades @Input()
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['autoridadesLista']) {
      this.procesarAutoridades();
      setTimeout(() => this.checkScroll(), 100);
    }
  }
  ngOnInit(): void {
      this.procesarAutoridades();
  }

  procesarAutoridades(): void {
    if (!this.autoridadesLista || this.autoridadesLista.length === 0) {
      this.autoridadPrincipal = null;
      this.restoAutoridades = [];
      return;
    }

  

    
    this.restoAutoridades = this.autoridadesLista;
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.checkScroll(), 100);
  }

  fallbackFoto(event: Event) {
    const elementoImg = event.target as HTMLImageElement;
    elementoImg.src = 'assets/img/default.png';
  }
scrollHorizontal(container: HTMLElement, m: number): void {
  // m debe recibir 1 (para avanzar a la derecha) o -1 (para retroceder a la izquierda)
  
  // Calculamos la distancia base en píxeles:
  // En mobile: 90% del ancho total de la pantalla (window.innerWidth * 0.9)
  // En desktop: 300px
  const baseDistance = this.isMobile 
    ? (window.innerWidth * 0.9) 
    : 300;

  // Multiplicamos por 'm' para conservar el sentido (-90% o +90%)
  const scrollAmount = baseDistance * m;

  container.scrollBy({
    left: scrollAmount,
    behavior: 'smooth'
  });

  setTimeout(() => this.checkScroll(), 300);
}

  checkScroll(): void {
    if (!this.sliderRef) return;

    const el = this.sliderRef.nativeElement;

    this.canScrollLeft = el.scrollLeft > 5;

    const maxScroll = el.scrollWidth - el.clientWidth;
    this.canScrollRight = el.scrollLeft < maxScroll - 5;
  }
    get isMobile(): boolean {
    return window.innerWidth <= 738; 
  }
}
